/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import { ISettingGroupDefinition } from "@nuance/hierarchical-settings-ui-domain";
import { fileOpen, fileSave } from "browser-fs-access";
import { getLogger, ILogger } from "@nuance/hux-diagnostics";

const logger: ILogger = getLogger();

/**
 * Open the file and return the contents of the file.
 * @param mimeType The mimeType used to filter.
 */
export const openSettingsDefinitionFile = async (
    mimeType: string
): Promise<ISettingGroupDefinition> => {
    const blob = await fileOpen({
        mimeTypes: [mimeType]
    });

    const json = await blob.text();
    const settingDefinition: ISettingGroupDefinition = JSON.parse(json);
    return settingDefinition;
};

/**
 * Displays the save to file dialog to allow the user to
 * save the setting definition to file.
 *
 * @param definition Setting group definition to save
 */
export const saveSettingsDefinitionFile = async (
    definition: ISettingGroupDefinition
): Promise<void> => {
    const fileName = `${definition.SettingGroupName}.json`;
    const blob = new Blob([JSON.stringify(definition)]);
    try {
        await fileSave(blob, { fileName });
    } catch (ex) {
        if (ex instanceof Error) {
            logger.logException(ex, "Error saving file");
        }
    }
};
